import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { GetReportingToService } from '../helper/get-reporting-to';
import { ParseService } from '../parse/parse.service';
import { StorageConfiguration } from '../storage-setting/storage-configuration';

@Component({
  selector: 'app-add-location',
  templateUrl: './add-location.component.html',
  styleUrls: ['./add-location.component.scss']
})
export class AddLocationComponent implements OnInit {

  locationForm: FormGroup;
  isEdit = false;
  profileId = '';
  tenantId = '';
  organisationLists = [];

  constructor(
    private formBuilder: FormBuilder,
    private parseService: ParseService,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private storageConfiguration: StorageConfiguration,
    private getReportingToService: GetReportingToService,

  ) {
    this.profileId = this.parseService.instance.User.current().get('profile').id;
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    this.locationForm = this.formBuilder.group({
      location: ['', Validators.required]
    });
  }

  ngOnInit() {
    this.getOrganisation();
    if (this.data.isEdit == true) {
      this.editLocation();
    }
  }

  async addLocation() {
    if (this.locationForm.valid) {
      let values = this.locationForm.value;
      let locationClass = this.parseService.instance.Object.extend('Location');
      var locationDetails = new locationClass();
      locationDetails.set('name', values.location);
      locationDetails.set('isActive', true);
      locationDetails.set('tenantId',this.tenantId);
      locationDetails.set('createdBy', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
      let data = await locationDetails.save();
      this.toastr.success('Saved successfully.');
      this.dialog.closeAll();
    }
    else {
      this.toastr.warning('Please enter the required fields');
    }
  }

  async editLocation() {
    this.isEdit = this.data.isEdit;
    const locationInstance = this.parseService.instance.Object.extend('Location');
    const locationQuery = new this.parseService.instance.Query(locationInstance);
    locationQuery.equalTo('objectId', this.data.id);
    const locationResults = await locationQuery.find();
    let data = locationResults[0];
    this.locationForm.patchValue({
      location: data.get('name')
    });
  }

  async updateLocation() {
    if (this.locationForm.valid) {
      let values = this.locationForm.value;
      const locationInstance = this.parseService.instance.Object.extend('Location');
      const locationQuery = new this.parseService.instance.Query(locationInstance);
      locationQuery.equalTo('objectId', this.data.id);
      const locationResults = await locationQuery.find();
      let data = locationResults[0];
      data.set('name', values.location);
      let res = await data.save();
      this.toastr.success('Updated successfully.');
      this.dialog.closeAll();
    }
    else {
      this.toastr.warning('Please enter the required fields');
    }
  }

  closepopup() {
    this.dialog.closeAll();
  }

  async getOrganisation() {
    await this.getReportingToService.getOrganisation().then(res => {
      this.organisationLists = res;
    });
  }

}

